import React, { useState } from "react";
import { DeploymentUnitOutlined, ShareAltOutlined, ScheduleOutlined } from "@ant-design/icons";
import { Card, Tabs } from "antd";
import { FormattedMessage } from "react-intl";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import queryString from "query-string";

import { selectors as ACCOUNT_SELECTORS } from "../../ducks/account";

import OwnChannelList from "./OwnChannelList";
import SharedChannelList from "./SharedChannelList";
import CreateChannelModal from "./ChannelModal/CreateChannelModal";
import AllChannelsList from "./AllChannelsList";
import GlobalErrorBoundaries from "../../components/ErrorBoundaries/GlobalErrorBoundaries";

import { ROLE } from "../../lib/utils/constants";
import { history } from "../../store";

const { TabPane } = Tabs;

const TABS = {
  OWN: "own",
  SHARED: "shared",
  VERIFICATION: "verification",
};

const ChannelsListContainer = ({ role }) => {
  const isAdmin = role === ROLE.ADMIN;
  const isSupport = role === ROLE.SUPPORT;

  const {
    location: { search, pathname },
  } = window;

  const { tab } = queryString.parse(search);
  const [activeKey, setActiveKey] = useState(tab);

  const handleChangeTab = (selectedTab) => {
    setActiveKey(selectedTab);

    history.push({
      pathname,
      search: `?tab=${selectedTab}`,
    });
  };

  return (
    <GlobalErrorBoundaries>
      <Card extra={<CreateChannelModal />}>
        <Tabs onChange={handleChangeTab} activeKey={activeKey}>
          <TabPane
            tab={
              <span>
                <DeploymentUnitOutlined />
                <FormattedMessage id="ChannelsListContainer.myHubChannels" defaultMessage="My hub channels" />
              </span>
            }
            key={TABS.OWN}
          >
            <OwnChannelList />
          </TabPane>
          <TabPane
            tab={
              <span>
                <ShareAltOutlined />
                <FormattedMessage id="ChannelsListContainer.shared" defaultMessage="Shared with me" />
              </span>
            }
            key={TABS.SHARED}
          >
            <SharedChannelList />
          </TabPane>
          {(isAdmin || isSupport) && (
            <TabPane
              tab={
                <span>
                  <ScheduleOutlined />
                  <FormattedMessage
                    id="ChannelsListContainer.channelsHubVerification"
                    defaultMessage="Hub channels verification"
                  />
                </span>
              }
              key={TABS.VERIFICATION}
            >
              <AllChannelsList />
            </TabPane>
          )}
        </Tabs>
      </Card>
    </GlobalErrorBoundaries>
  );
};

ChannelsListContainer.propTypes = {
  role: PropTypes.string,
};

ChannelsListContainer.defaultProps = {
  role: "user",
};

const mapStateToProps = (state) => ({
  role: ACCOUNT_SELECTORS.getRole(state),
});

export default connect(mapStateToProps, null)(ChannelsListContainer);
